import Login from "pages/Authentication/Login";
import Logout from "pages/Authentication/LogOut";
import Register from "pages/Authentication/Register";
import UserListView from "pages/Users";
import Conversation from "pages/Conversation";
import Communication from "pages/Communication";
import Friends from "pages/Friends";
import Home from "pages/Home";
import Contact from "pages/Contact";
import ImportContacts from "pages/Contact/ImportContacts";
import Calendar from "pages/Calendar/Index";
import StaffSchedule from "pages/StaffSchedule/Index";
import Campaign from "pages/Campaign/Index";
import Dashboard from "pages/Dashboard/Index";
import WorkflowList from "pages/Workflow/WorkflowList";
import WorkflowDesigner from "pages/Workflow/WorkflowDesigner";
import Knowledge from "pages/Knowledge/Index";
import CreateKnowledge from "pages/Knowledge/CreateKnowledge";
import DocumentDetail from "pages/Knowledge/DocumentDetail";
import Documents from "pages/Knowledge/Documents";
import UpdateKnowledge from "pages/Knowledge/UpdateKnowledge";
import CampaignAgent from "pages/Campaign/CampaignAgent";

interface RouteObject {
  path: string;
  component: React.ComponentType<any>; // Use React.ComponentType to specify the type of the component
  exact?: boolean;
}

const authProtectedRoutes: Array<RouteObject> = [
  { path: "/", component: Conversation },
  { path: "/home", component: Home },
  { path: "/conversation", component: Conversation },
  { path: "/communication", component: Communication },
  { path: "/friends", component: Friends },
  { path: "/contact", component: Contact },
  { path: "/contact/import", component: ImportContacts },
  { path: "/calendar", component: Calendar },
  { path: "/user", component: UserListView },
  { path: "/schedule", component: StaffSchedule },
  { path: "/campaign", component: Campaign },
  {
    path: "/campaign/campaign-agent/:emailCampaignId/:mode",
    component: CampaignAgent,
  },
  { path: "/campaign/campaign-agent", component: CampaignAgent },
  { path: "/dashboard", component: Dashboard },
  { path: "/workflow", component: WorkflowList },
  { path: "/workflow/designer", component: WorkflowDesigner },
  { path: "/workflow/designer/:id", component: WorkflowDesigner },
  { path: "/knowledge", component: Knowledge },
  { path: "/knowledge/create", component: CreateKnowledge },
  {
    path: "/knowledge/:knowledgeId/document/create",
    component: UpdateKnowledge,
  },
  { path: "/knowledge/:knowledgeId/documents", component: Documents },
  {
    path: "/knowledge/:knowledgeId/documents/:documentId",
    component: DocumentDetail,
  },
];

const publicRoutes = [
  // authentication
  { path: "/login", component: Login },
  { path: "/logout", component: Logout },
  { path: "/register", component: Register },
];

export { authProtectedRoutes, publicRoutes };
